import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  EnrollmentSteps,
  Validators,
  formDataDefault,
  fromOperatorDefault,
  STATE_OPTIONS,
} from "Utils/Constants";

import TextField from "Components/Fields/TextField";
import { Regexes } from "Utils/Regexes";
import SelectField from "Components/Fields/SelectField";

const AddressFields = ({
  formData = formDataDefault,
  fromOperator = fromOperatorDefault,
  onFieldChange = (fieldName, fieldValue, isValid) => {
    console.warn("onFieldChange not set.");
  },
  disabled = false,
}) => {
  return (
    <>
      <Row>
        {fromOperator.address?.includes(EnrollmentSteps.ADDRESS.ADDRESS) && (
          <Col xs={10}>
            <TextField
              fieldName="streetName"
              label="ADDRESS"
              maxLength="30"
              startValue={formData.streetName}
              required={true}
              allowedCharacters={Regexes.ADDRESS.ALLOWED_CHARACTERS}
              validators={[Validators.ADDRESS]}
              onValueChanged={onFieldChange}
              disabled={disabled}
            />
          </Col>
        )}
        {fromOperator.address?.includes(EnrollmentSteps.ADDRESS.UNIT) && (
          <Col xs={2}>
            <TextField
              fieldName="unit"
              label="UNIT/APT#"
              maxLength="5"
              startValue={formData.unit}
              allowedCharacters={Regexes.UNIT.ALLOWED_CHARACTERS}
              validators={[Validators.UNIT]}
              onValueChanged={onFieldChange}
              disabled={disabled}
            />
          </Col>
        )}
      </Row>
      <Row>
        {fromOperator.address?.includes(EnrollmentSteps.ADDRESS.CITY) && (
          <Col xs={8} md={7}>
            <TextField
              fieldName="city"
              label="CITY"
              maxLength="20"
              startValue={formData.city}
              required={true}
              allowedCharacters={Regexes.CITY.ALLOWED_CHARACTERS}
              validators={[Validators.CITY]}
              onValueChanged={onFieldChange}
              disabled={disabled}
            />
          </Col>
        )}
        {fromOperator.address?.includes(EnrollmentSteps.ADDRESS.STATE) && (
          <Col xs={4} md={2}>
            <SelectField
              fieldName="state"
              label="STATE"
              options={STATE_OPTIONS}
              startValue={formData.state}
              required={true}
              onValueChanged={onFieldChange}
              disabled={disabled}
            />
          </Col>
        )}
        {fromOperator.address?.includes(EnrollmentSteps.ADDRESS.ZIP) && (
          <Col xs={6} md={3}>
            <TextField
              fieldName="zip"
              label="ZIP"
              maxLength="10"
              startValue={formData.zip}
              required={true}
              allowedCharacters={Regexes.ZIP.ALLOWED_CHARACTERS}
              validators={[Validators.ZIP]}
              onValueChanged={onFieldChange}
              disabled={disabled}
            />
          </Col>
        )}
      </Row>
    </>
  );
};
export default AddressFields;
